import MainHeader from "../Components/MainHeader";
import './Award.css'


const Award = () => {
    const parentFunction = (x) => {};
  
    const imagePaths = [
      "award/distance1000_km.png",
      "award/distance5000_km.png",
      "award/distance10000_km.png",
      "award/distance30000_km.png",
      "award/distance50000_km.png",
      "award/elevation1.png",
      "award/elevation10.png",
      "award/elevation30.png",
      "award/elevation50.png",
      "award/elevation100.png",
      "award/ride100_time.png",
      "award/ride300_time.png",
      "award/ride500_time.png",
      "award/ride1000_time.png",
      "award/ride2000_time.png",
      "award/30km_30km.png",
      "award/30km_40km.png",
      "award/100km_30km.png",
      "award/100km_40km.png",
      "award/gosu.png",
    ];

    const textContents = ["Total Ride Distance AWARD", "Total Elevation AWARD (에베레스팅 횟수)", "Number of Ride AWARD", "AVG Speed AWARD", ""];

    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const totalDistance = (userData?.totalDistance)/1000 || 0;
    const totalElevation = (userData?.totalElevation) || 0;
    const rideCount = userData?.rides?.length || 0;
    const avg50 = userData?.avg50 || 0;
    const avg100 = userData?.avg100 || 0;
    const gosu = userData?.gosu || 0;
    const joule = userData.totalJoule;

    const time = joule / (60 * 60 * 100);



    const renderImages = () => {
      const images = [];
      for (let i = 0; i < time; i++) {
        images.push(
            <img className="image-wrapper" src="bulb.png" alt="이미지" />
        );
      }
      return images;
    };

return (
    <div>
      <MainHeader parentFunction={parentFunction} />

      <a>
  <span style={{ display: 'block', textAlign: 'center', fontWeight: 'bold', fontSize: '3vw'}}>
    사용자의 Strava 데이터를 분석하여 이를 도전과제화 하였습니다. <br/>더 많이, 더 멀리, 더 높히 라이딩 하세요
  </span>
</a>

      <div className="image-grid">
        <div className="imgDsc">
          <div className="description-line">
            <div className="description-text">{textContents[0]}</div>
          </div>
          <div className="image-line">
            {imagePaths.slice(0, 5).map((imageName, index) => {
              let isHighlighted = false;
              if (index === 0 && totalDistance >= 3000) {
                isHighlighted = true;
              } else if (index === 1 && totalDistance >= 5000) {
                isHighlighted = true;
              } else if (index === 2 && totalDistance >= 10000) {
                isHighlighted = true;
              } else if (index === 3 && totalDistance >= 30000) {
                isHighlighted = true;
              } else if (index === 4 && totalDistance >= 50000) {
                isHighlighted = true;
              }

              const imageClass = isHighlighted ? "grid-item highlighted" : "grid-item";

              return (
                <div className="image-container" key={index}>
                  <img src={`${imageName}`} alt={imageName} className={imageClass} />
                </div>
              );
            })}
          </div>
        </div>

        <div className="imgDsc">
          <div className="description-line">
            <div className="description-text">{textContents[1]}</div>
          </div>
          <div className="image-line">
            {imagePaths.slice(5, 10).map((imageName, index) => {
              let isHighlighted = false;
              if (index === 0 && totalElevation >= 8848 * 1) {
                isHighlighted = true;
              } else if (index === 1 && totalElevation >= 8848 * 10) {
                isHighlighted = true;
              } else if (index === 2 && totalElevation >= 8848 * 30) {
                isHighlighted = true;
              } else if (index === 3 && totalElevation >= 8848 * 50) {
                isHighlighted = true;
              } else if (index === 4 && totalElevation >= 8848 * 100) {
                isHighlighted = true;
              }

              const imageClass = isHighlighted ? "grid-item highlighted" : "grid-item";

              return (
                <div className="image-container" key={index}>
                  <img src={`${imageName}`} alt={imageName} className={imageClass} />
                </div>
              );
            })}
          </div>
        </div>

        <div className="imgDsc">
          <div className="description-line">
            <div className="description-text">{textContents[2]}</div>
          </div>
          <div className="image-line">
            {imagePaths.slice(10, 15).map((imageName, index) => {
              let isHighlighted = false;

              if (index === 0 && rideCount >= 100) {
                isHighlighted = true;
              } else if (index === 1 && rideCount >= 300) {
                isHighlighted = true;
              } else if (index === 2 && rideCount >= 500) {
                isHighlighted = true;
              } else if (index === 3 && rideCount >= 1000) {
                isHighlighted = true;
              } else if (index === 4 && rideCount >= 2000) {
                isHighlighted = true;
              }

              const imageClass = isHighlighted ? "grid-item highlighted" : "grid-item";

              return (
                <div className="image-container" key={index}>
                  <img src={`${imageName}`} alt={imageName} className={imageClass} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="image-gird2">
          <div className="imgDsc">
            <div className="description-line">
                <div className="description-text">{textContents[3]}</div>
            </div>

            <div className="image-line">
            {imagePaths.slice(15, 19).map((imageName, index) => {
              let isHighlighted = false;

              if (index === 0 && avg50 === 1) {
                isHighlighted = true;
              } else if (index === 1 && avg50 === 2) {
                isHighlighted = true;
              } else if (index === 2 && avg100 === 1) {
                isHighlighted = true;
              } else if (index === 3 && avg100 === 2) {
                isHighlighted = true;
              }

              const imageClass = isHighlighted ? "grid-item highlighted" : "grid-item";

              return (
                <div className="image-container" key={index}>
                  <img src={`${imageName}`} alt={imageName} className={imageClass} />
                </div>
              );
            })}
          </div>        
          </div>
      </div>


      <div className="image-gird3">
          <div className="imgDsc">
            <div className="description-line">
                <div className="description-text">{textContents[4]}</div>
            </div>

            <div className="image-line">
            {imagePaths.slice(19, 20).map((imageName, index) => {
              let isHighlighted = false;
              if (index === 0 && gosu ===1){
                isHighlighted = true;
              }

              const imageClass = isHighlighted ? "grid-item highlighted" : "grid-item";

              return (
                <div className="image-container" key={index}>
                  <img src={`${imageName}`} alt={imageName} className={imageClass} />
                </div>
              );
            })}
          </div>        
          </div>
      </div>

      <div>
        <span style={{ display: 'block', textAlign: 'center', fontSize: '2vw'}}>
          현재까지 {rideCount}번, {totalDistance}라이딩하면서 생산한 에너지는 총 {joule} Joule입니다. <br/>60W 짜리 백열전구 {time.toFixed()}개를 동시에 100시간동안 켤 수 있는 수준이네요. <br/>{time.toFixed()}개의 전구는 이정도 쯤 됩니다.
          </span>
        <div>
          {renderImages()}
        </div>
      </div>

    </div>
  );
};

  

export default Award;